import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePlatform } from '../../context/PlatformContext';
import { FaMap, FaPlus, FaChartBar, FaBars, FaTimes, FaSignOutAlt, FaLeaf, FaCog, FaTags } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const { currentUser, logout, userProfile } = useAuth();
  const { isMobileApp } = usePlatform();
  const isCorporate = userProfile?.role === 'subscriber' ||
    userProfile?.subscription?.active ||
    userProfile?.subscription?.type;
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          🗺️ WasteMapr.com
        </Link>

        <div className="navbar-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={menuOpen ? 'navbar-menu active' : 'navbar-menu'}>
          {currentUser && (
            <>
              <li className="navbar-item">
                <Link to="/map" className="navbar-link" onClick={() => setMenuOpen(false)}>
                  <FaMap /> Map
                </Link>
              </li>

              <li className="navbar-item">
                <Link to="/individual-dashboard" className="navbar-link" onClick={() => setMenuOpen(false)}>
                  <FaLeaf /> Personal Dashboard
                </Link>
              </li>

              {!isMobileApp && isCorporate && (
                <li className="navbar-item">
                  <Link to="/corporate-dashboard" className="navbar-link navbar-corporate" onClick={() => setMenuOpen(false)}>
                    <FaChartBar /> Corporate Dashboard
                  </Link>
                </li>
              )}

              <li className="navbar-item">
                <Link to="/report" className="navbar-link" onClick={() => setMenuOpen(false)}>
                  <FaPlus /> Report Waste
                </Link>
              </li>
            </>
          )}


          {currentUser ? (
            <>
              <li className="navbar-item">
                <Link to="/account" className="navbar-link" onClick={() => setMenuOpen(false)}>
                  <FaCog /> Account
                </Link>
              </li>
              <li className="navbar-item">
                <button className="navbar-link navbar-logout" onClick={handleLogout}>
                  <FaSignOutAlt /> Logout
                </button>
              </li>
            </>
          ) : (
            <>
              {!isMobileApp && (
                <li className="navbar-item">
                  <Link to="/pricing" className="navbar-link" onClick={() => setMenuOpen(false)}>
                    <FaTags /> Pricing
                  </Link>
                </li>
              )}
              <li className="navbar-item">
                <Link to="/login" className="navbar-link" onClick={() => setMenuOpen(false)}>
                  Login
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/signup" className="navbar-link navbar-signup" onClick={() => setMenuOpen(false)}>
                  Sign Up
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
